interface TocItem {
    id: string;
    text: string;
    level: number;
}

interface ParseHeadingsResult {
    processedContent: string;
    tocItems: TocItem[];
    secondH2Position: number | null;
}

export const parseHtmlHeadings = (content: string): ParseHeadingsResult => {
    const headingPattern = /<h([2-4])(?:\s+[^>]*?)?>(.*?)<\/h\1>/g;
    const tocItems: TocItem[] = [];

    // First: process headings and add IDs
    const processedContent = content.replace(headingPattern, (match, level, innerHtml, offset) => {
        const text = stripTags(innerHtml).trim();
        if (!text) return match;

        const id = generateSlug(text);
        tocItems.push({ id, text, level: parseInt(level) });

        const tagStart = match.indexOf('>');
        const openingTag = match.slice(0, tagStart);

        const newOpeningTag = openingTag.includes('id=')
            ? openingTag.replace(/id=["'][^"']*["']/, `id="${id}"`)
            : `${openingTag} id="${id}"`;

        return `${newOpeningTag}>${innerHtml}</h${level}>`;
    });

    // Second: find position of second H2 in PROCESSED content
    let h2Count = 0;
    let secondH2Position: number | null = null;
    const h2Pattern = /<h2(?:\s+[^>]*?)?>/g;
    let h2Match;
    while ((h2Match = h2Pattern.exec(processedContent)) !== null) {
        h2Count++;
        if (h2Count === 2) {
            secondH2Position = h2Match.index;
            break;
        }
    }

    return { processedContent, tocItems, secondH2Position };
};

const stripTags = (html: string): string => {
    return html.replace(/<[^>]+>/g, '');
};
const generateSlug = (text: string): string => {
    return text
        .toLowerCase()
        .replace(/[^\wа-яё\s-]/g, '') // Разрешаем только буквы, цифры, пробелы и дефисы
        .trim()
        .replace(/\s+/g, '-') // Заменяем пробелы на дефисы
        .replace(/-+/g, '-') // Убираем повторяющиеся дефисы
        .substring(0, 50); // Ограничиваем длину slug
};